<script lang="ts">
	import type { SelectAssetsAssetFilter, SelectAssetsSaveFilter } from './Library.svelte';

	export let savedName: string = 'Favorites';
	export let includeAll: boolean = true;
	export let allName: string = 'All';
	export let showSaveFilter: boolean = true;
	export let showAssetFilter: boolean = true;
	export let saveFilter: SelectAssetsSaveFilter = 'saved';
	export let assetFilter: SelectAssetsAssetFilter = 'image';

	export const onPressShowSavedButton = () => {
		saveFilter = 'saved';
	};

	export const onPressShowAllButton = () => {
		saveFilter = 'all';
	};

	export const onPressShowImageTypeButton = () => {
		assetFilter = 'image';
	};

	export const onPressShow3DTypeButton = () => {
		assetFilter = '3d';
	};
</script>

<div
	class="w-full flex flex-row justify-start items-center text-zinc-900 dark:text-zinc-200 text-xs"
>
	{#if showSaveFilter}
		<div
			class="w-[5.7rem] h-16 flex flex-col justify-center items-center border rounded font-semibold
			border-primary-200 dark:border-zinc-800"
		>
			{#if saveFilter === 'saved'}
				<button
					class="h-8 w-full
					bg-cyan-500 bg-opacity-75
					dark:bg-navy-900 dark:brightness-150 dark:border dark:border-cyan-900 dark:bg-opacity-100
					rounded-tl rounded-tr">{savedName}</button
				>
			{:else}
				<button
					class="h-8 w-full
					bg-primary-50 hover:brightness-90
					dark:bg-navy-900 dark:hover:brightness-150 dark:border-navy-900
				  rounded-tl rounded-tr"
					on:click={onPressShowSavedButton}>{savedName}</button
				>
			{/if}
			{#if includeAll}
				{#if saveFilter === 'all'}
					<button
						class="h-8 w-full
						bg-cyan-500 bg-opacity-75
						dark:bg-navy-900 dark:brightness-150 dark:border dark:border-cyan-900 dark:bg-opacity-100
						rounded-bl rounded-br">{allName}</button
					>
				{:else}
					<button
						class="h-8 w-full
						bg-primary-50 hover:brightness-90
						dark:bg-navy-900 dark:hover:brightness-150 dark:border-navy-900
						rounded-bl rounded-br"
						on:click={onPressShowAllButton}
					>
						{allName}
					</button>
				{/if}
			{/if}
		</div>
		<div class="w-2"></div>
	{/if}
	{#if showAssetFilter}
		<div
			class="w-[5.7rem] h-16 flex flex-col justify-center items-center border rounded border-zinc-800 font-semibold"
		>
			{#if assetFilter === 'image'}
				<button
					class="h-8 w-full
					bg-cyan-200
					dark:bg-navy-900 dark:brightness-150 dark:border dark:border-cyan-900
					rounded-tl rounded-tr">Images</button
				>
			{:else}
				<button
					class="h-8 w-full
					bg-primary-50 hover:brightness-90
					dark:bg-navy-900 dark:hover:brightness-150 dark:border-navy-900
					rounded-tl rounded-tr"
					on:click={onPressShowImageTypeButton}>Images</button
				>
			{/if}
			{#if assetFilter === '3d'}
				<button
					class="h-8 w-full
					bg-cyan-200
					dark:bg-navy-900 dark:brightness-150 dark:border dark:border-cyan-900
					rounded-bl rounded-br">3D models</button
				>
			{:else}
				<button
					class="h-8 w-full
					bg-primary-50 hover:brightness-90
					dark:bg-navy-900 dark:hover:brightness-150 dark:border-navy-900
					rounded-bl rounded-br"
					on:click={onPressShow3DTypeButton}
				>
					3D models
				</button>
			{/if}
		</div>
		<div class="w-2"></div>
	{/if}
</div>
